import { render } from "./recoverStatusCard.vue?vue&type=template&id=b8c221f4"
import script from "./recoverStatusCard.vue?vue&type=script&lang=js"
export * from "./recoverStatusCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__